import { ref } from 'vue'
import type { IChatTopic } from '@/modules/chat-matrix-fast/types/IChat'

export const useChatModals = () => {
  const isUserProfileSidebarOpen = ref(false)
  const isEmployeeProfileOpen = ref(false)
  const isDeleteChatDialogOpen = ref(false)
  const isLeaveGroupDialogOpen = ref(false)
  const isFilesAndMediaDialogOpen = ref(false)
  const isFileUploadDialogOpen = ref(false)
  const isCreateGroupDialogOpen = ref(false)
  const isManageGroupDialogOpen = ref(false)
  const isGroupInfoDialogOpen = ref(false)
  const isCreateTopicDialogOpen = ref(false)
  const topicDialogMode = ref<'create' | 'rename'>('create')
  const renamingTopic = ref<IChatTopic | null>(null)
  const isDeletingChat = ref(false)
  const isLeavingGroup = ref(false)
  const employeeId = ref<string>('')
  /** Файлы из Ctrl+V — передаются в FileUploadDialog при открытии */
  const pendingUploadFiles = ref<File[]>([])

  const openUserProfile = () => {
    isUserProfileSidebarOpen.value = true
  }

  const closeUserProfile = () => {
    isUserProfileSidebarOpen.value = false
  }

  const openEmployeeProfile = (id: string) => {
    if (isEmployeeProfileOpen.value && employeeId.value !== id) {
      isEmployeeProfileOpen.value = false
      setTimeout(() => {
        employeeId.value = id
        isEmployeeProfileOpen.value = true
      }, 0)
    } else {
      employeeId.value = id
      isEmployeeProfileOpen.value = true
    }
  }

  const closeEmployeeProfile = () => {
    isEmployeeProfileOpen.value = false
    employeeId.value = ''
  }

  const openDeleteChatDialog = () => {
    isDeleteChatDialogOpen.value = true
  }

  const closeDeleteChatDialog = () => {
    isDeleteChatDialogOpen.value = false
  }

  const openFilesAndMediaDialog = () => {
    isFilesAndMediaDialogOpen.value = true
  }

  const openFileUploadDialog = (files?: File[]) => {
    pendingUploadFiles.value = files?.length ? [...files] : []
    isFileUploadDialogOpen.value = true
  }

  const takePendingUploadFiles = (): File[] => {
    const files = pendingUploadFiles.value
    pendingUploadFiles.value = []
    return files
  }

  const openCreateGroupDialog = () => {
    isCreateGroupDialogOpen.value = true
  }

  const openManageGroupDialog = () => {
    isManageGroupDialogOpen.value = true
  }

  const openGroupInfoDialog = () => {
    isGroupInfoDialogOpen.value = true
  }

  const openCreateTopicDialog = () => {
    topicDialogMode.value = 'create'
    renamingTopic.value = null
    isCreateTopicDialogOpen.value = true
  }

  const openRenameTopicDialog = (topic: IChatTopic) => {
    topicDialogMode.value = 'rename'
    renamingTopic.value = topic
    isCreateTopicDialogOpen.value = true
  }

  const openLeaveGroupDialog = () => {
    isLeaveGroupDialogOpen.value = true
  }

  const closeLeaveGroupDialog = () => {
    isLeaveGroupDialogOpen.value = false
  }

  return {
    isUserProfileSidebarOpen,
    isEmployeeProfileOpen,
    isDeleteChatDialogOpen,
    isLeaveGroupDialogOpen,
    isFilesAndMediaDialogOpen,
    isFileUploadDialogOpen,
    isCreateGroupDialogOpen,
    isManageGroupDialogOpen,
    isGroupInfoDialogOpen,
    isCreateTopicDialogOpen,
    topicDialogMode,
    renamingTopic,
    isDeletingChat,
    isLeavingGroup,
    employeeId,
    pendingUploadFiles,
    openUserProfile,
    closeUserProfile,
    openEmployeeProfile,
    closeEmployeeProfile,
    openDeleteChatDialog,
    closeDeleteChatDialog,
    openLeaveGroupDialog,
    closeLeaveGroupDialog,
    openFilesAndMediaDialog,
    openFileUploadDialog,
    takePendingUploadFiles,
    openCreateGroupDialog,
    openManageGroupDialog,
    openGroupInfoDialog,
    openCreateTopicDialog,
    openRenameTopicDialog,
  }
}
